import angular = require("angular");
import TPL = require("templates");

export class CompareToDirective {

  restrict = "A";
  scope = {
    otCompareTo: "=otCompareTo"
  };
  require = "ngModel";
  link;

  constructor() {
    this.link = (scope, el, attrs, ctrl)=> {

      var validatorFn = function(modelValue, viewValue) {

        var value = modelValue || viewValue;
        var valid = true;

        if (value) {
          valid = scope.otCompareTo == value;
        }

        return valid;
      }

      ctrl.$validators["compareTo"] = validatorFn;

      scope.$watch("otCompareTo", (newValue) => {
        ctrl.$validate();
      });

    }

  }

  static factory() {
    var tmp = () => new CompareToDirective();
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/services/compareTo.ts
 **/